import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectsState, Project } from './projectsTypes';
import { projectsAPI } from './projectsAPI';

const initialState: ProjectsState = {
  currentProject: null,
  projects: [],
  agents: [],
  tasks: [],
  codeGenerations: [],
  loading: false,
  error: null,
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setCurrentProject: (state, action: PayloadAction<Project | null>) => {
      state.currentProject = action.payload;
    },
    clearProjectsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Projects
    builder.addMatcher(
      projectsAPI.endpoints.getProjects.matchPending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    );
    builder.addMatcher(
      projectsAPI.endpoints.getProjects.matchFulfilled,
      (state, action) => {
        state.loading = false;
        state.projects = action.payload;
      }
    );
    builder.addMatcher(
      projectsAPI.endpoints.getProjects.matchRejected,
      (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to fetch projects';
      }
    );
    
    // Get Agents
    builder.addMatcher(
      projectsAPI.endpoints.getAgents.matchFulfilled,
      (state, action) => {
        state.agents = action.payload;
      }
    );
    
    // Get Agent Tasks
    builder.addMatcher(
      projectsAPI.endpoints.getAgentTasks.matchFulfilled,
      (state, action) => {
        state.tasks = action.payload;
      }
    );
    
    // Get Code Generations
    builder.addMatcher(
      projectsAPI.endpoints.getCodeGenerations.matchFulfilled,
      (state, action) => {
        state.codeGenerations = action.payload;
      }
    );
  },
});

export const { setCurrentProject, clearProjectsError } = projectsSlice.actions;
export default projectsSlice.reducer;
